const Module = () => import('./Module.vue')
const Dashboard = () => import('./views/Dashboard.vue')

const moduleRoute = {
  path: '/home',
  component: Module,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      name: 'Home',
      path: '',
      component: Dashboard
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
